define.alias("shared/utils/constants/days", "calendar/utils/constants/days");